import React, { useState, useRef, useEffect } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Cookies from "js-cookie";
import { fabric } from "fabric";
import "../Styles/afis-olusturucu-premium.css";
import { LAYOUTS } from "../Constants/PosterLayouts";

const TEST_IMAGES = [
  { src: "/Assets/badges/testVerisi/veysiDenli.png",    isim: "Veysi Denli" },
  { src: "/Assets/badges/testVerisi/testUserAfis.png",  isim: "Test Kullanıcı" },
  { src: "/Assets/badges/testVerisi/mevlutEren.png",    isim: "Mevlüt Eren" },
  { src: "/Assets/badges/testVerisi/nidaKaradeniz.png", isim: "Nida Karadeniz" },
  { src: "/Assets/badges/testVerisi/cananKayacı.png",   isim: "Canan Kayacı" },
];
const RANK_OPTIONS = [
  "6 Yıldız","7 Yıldız","8 Yıldız",
  "Bronz Aslan","Gümüş Aslan","Altın Aslan",
  "Yıldız Altın Aslan","Yönetici","Onursal Yönetici",
];
const DAY_OPTIONS = ["PAZARTESİ","SALI","ÇARŞAMBA","PERŞEMBE","CUMA","CUMARTESİ","PAZAR"];
const PERSON_COUNT_MAP = {
  "Online Program":  ["Tek Kişilik","2 Kişilik","3 Kişilik","4 Kişilik","5 Kişilik","6 Kişilik","8 Kişilik","9 Kişilik","12 Kişilik","16 Kişilik"],
  "Offline Program": ["Tek Kişilik","2 Kişilik","3 Kişilik","4 Kişilik","5 Kişilik","6 Kişilik","8 Kişilik","9 Kişilik"],
};
const randomFrom = (a) => a[Math.floor(Math.random() * a.length)];

const loadImage = (url) => new Promise((resolve) => {
  fabric.Image.fromURL(url, (img) => resolve(img), { crossOrigin: "anonymous" });
});

/* ══════════════════════════════════════════════════
   Inline Fabric.js Editörü
══════════════════════════════════════════════════ */
function FabricEditor({ posterUrl, personList = [], formData }) {
  const canvasRef  = useRef(null);
  const fabricRef  = useRef(null);
  const wrapperRef = useRef(null);
  const [selectedObj, setSelectedObj] = useState(null);
  const [canUndo, setCanUndo] = useState(false);

  useEffect(() => {
    if (!posterUrl || !canvasRef.current || !wrapperRef.current) return;

    if (fabricRef.current) { fabricRef.current.dispose(); fabricRef.current = null; }

    const containerW = wrapperRef.current.clientWidth || 460;

    const tmpImg = new Image();
    tmpImg.onload = async () => {
      const scale = containerW / tmpImg.naturalWidth;
      const w = Math.round(tmpImg.naturalWidth * scale);
      const h = Math.round(tmpImg.naturalHeight * scale);

      const fc = new fabric.Canvas(canvasRef.current, {
        width: w, height: h,
        preserveObjectStacking: true,
        selection: true,
      });
      fabricRef.current = fc;
      fc.historyProcessing = true;

      /* Afişi arka plan olarak yükle */
      const bgImg = await loadImage(posterUrl);
      if (bgImg) {
        bgImg.scaleToWidth(w);
        fc.setBackgroundImage(bgImg, fc.renderAll.bind(fc));
      }

      const layoutKey = formData.kategori === "Kariyer Tebrik" && formData.altKategori ? formData.altKategori : `${formData.kategori} ${formData.kisiSayisi}`;
      const config = LAYOUTS[layoutKey] || LAYOUTS["Offline Program Tek Kişilik"];
      const isModernLayout = formData.kategori.includes("Online") || formData.kategori === "Offline Program";
      const profileBgName = formData.kategori === "Offline Program" ? "/Assets/Images/kullanıcıResmiBgOffline.png" : "/Assets/Images/kullanıcıResmiBg.png";
      const textColor = formData.kategori === "Offline Program" ? "#225134" : (formData.kategori === "Kariyer Tebrik" ? (layoutKey.includes("7 Yıldız") ? "#cbd5e0" : "#c5a059") : "#2b4c6e");

      /* Kişi elementlerini sırayla ekleyelim ki z-index doğru olsun */
      for (let i = 0; i < personList.length; i++) {
        const person = personList[i];
        const pCfg = config.persons[i];
        const textCfg = config.texts.names[i];
        if (!pCfg) continue;

        const bgWidth = Math.round(pCfg.width * 0.85);
        const photoWidth = formData.kategori === "Kariyer Tebrik" ? Math.round(pCfg.width * 0.90) : Math.round(pCfg.width * 0.60);
        const bgLeft = pCfg.left + Math.round((pCfg.width - bgWidth) / 2);
        const photoLeft = pCfg.left + Math.round((pCfg.width - photoWidth) / 2);
        const photoHeight = pCfg.height;
        const bgHeight = isModernLayout ? Math.round(pCfg.height * 0.45) : pCfg.height;
        const baseTop = pCfg.bgTop !== undefined ? pCfg.bgTop : pCfg.top;
        const bgTopCoord = (baseTop + pCfg.height - bgHeight);
        const photoTopCoord = (pCfg.top + pCfg.height - photoHeight - 14);

        // 1. Dalgalı Arkaplan
        if (formData.kategori !== "Kariyer Tebrik") {
          const wBgImg = await loadImage(profileBgName);
          if (wBgImg) {
            wBgImg.set({
              left: bgLeft * scale,
              top: bgTopCoord * scale,
              scaleX: (bgWidth * scale) / wBgImg.width,
              scaleY: (bgHeight * scale) / wBgImg.height,
              selectable: true,
              hasControls: true,
              borderColor: "#1a4d2e", cornerColor: "#1a4d2e", cornerSize: 8,
            });
            fc.add(wBgImg);
          }
        }

        // 2. Profil Fotoğrafı
        const pImg = await loadImage(person.src || person.previewUrl);
        if (pImg) {
          const minS = Math.min((photoWidth * scale) / pImg.width, (photoHeight * scale) / pImg.height);
          pImg.set({
            left: (photoLeft + photoWidth/2) * scale,
            top: (photoTopCoord + photoHeight) * scale,
            scaleX: minS, scaleY: minS,
            originX: "center", originY: "bottom", // Bottom alignment matching Sharp
            selectable: true,
            hasControls: true, borderColor: "#1a4d2e", cornerColor: "#1a4d2e", cornerSize: 10,
          });
          fc.add(pImg);
        }

        // 3. Rozet (Badge)
        if (person.unvan && pCfg.rankIcon && pCfg.rankIcon.width > 0) {
          let badgeName = `${person.unvan}.png`;
          if (formData.kategori === "Kariyer Tebrik") badgeName = "Tebrik Yıldızı.png";
          const bImg = await loadImage(`/Assets/badges/${badgeName}`);
          if (bImg) {
            let bTop = pCfg.rankIcon.top;
            let bLeft = pCfg.rankIcon.left;
            if (isModernLayout) {
              const isAkademi16 = layoutKey === "Günübirlik Akademi 16 Kişilik";
              const renderH = bImg.height * (pCfg.rankIcon.width / bImg.width);
              bTop = Math.round((pCfg.top + pCfg.height) - renderH - (isAkademi16 ? 39 : 9));
              bLeft = Math.round(photoLeft - (pCfg.rankIcon.width / 2) + (isAkademi16 ? 25 : -10));
            }
            bImg.set({
              left: bLeft * scale,
              top: bTop * scale,
              scaleX: (pCfg.rankIcon.width * scale) / bImg.width,
              scaleY: (pCfg.rankIcon.width * scale) / bImg.width,
              selectable: true,
              hasControls: true, borderColor: "#1a4d2e", cornerColor: "#1a4d2e", cornerSize: 8,
            });
            fc.add(bImg);
          }
        }

        // 4. İsim ve Ünvan Metinleri
        if (textCfg) {
          const fontFam = "Montserrat, sans-serif";
          const leftPos = textCfg.x === "50%" ? (1440/2) * scale : textCfg.x * scale;
          
          const nameTxt = new fabric.IText(person.isim.toUpperCase(), {
            left: leftPos,
            top: textCfg.y * scale,
            fontSize: textCfg.size * scale,
            fontFamily: fontFam,
            fontWeight: "bold",
            fill: textColor,
            originX: "center", originY: "baseline",
            selectable: true, hasControls: true, borderColor: "#1a4d2e", cornerColor: "#1a4d2e"
          });
          fc.add(nameTxt);

          if (textCfg.unvanY && person.unvan) {
            const unvanTxt = new fabric.IText(person.unvan.toUpperCase(), {
              left: leftPos,
              top: textCfg.unvanY * scale,
              fontSize: textCfg.unvanSize * scale,
              fontFamily: fontFam,
              fontWeight: "bold",
              underline: true,
              fill: textColor,
              originX: "center", originY: "baseline",
              selectable: true, hasControls: true, borderColor: "#1a4d2e", cornerColor: "#1a4d2e"
            });
            fc.add(unvanTxt);
          }
        }
      }

      // 5. Ana Metinler (Başlık, Alt Başlık, Tarih, Saat vs.)
      const mainTexts = ["baslik", "altBaslik", "egitimKonusu", "adres", "tarih", "saat", "gun"];
      mainTexts.forEach(key => {
        if (formData[key] && formData[key].trim() !== "") {
          let tCfg = config.texts?.[key];
          
          if (!tCfg) {
            if (key === "egitimKonusu") tCfg = { x: 75, y: 2250, size: 50, labelY: 2190 };
            else if (key === "adres") tCfg = { x: 160, y: 2320, size: 35 };
            else if (key === "tarih") tCfg = { x: 1195, y: 2320, size: 50 };
            else if (key === "saat") tCfg = { x: 1260, y: 2320, size: 50 };
            else if (key === "gun") tCfg = { x: 1195, y: 2400, size: 40 };
            else return; 
          }

          const fontFam = "Montserrat, sans-serif";
          let val = formData[key];
          if (key === "tarih" && val.includes("-")) { const [y,m,d] = val.split("-"); val = `${d}.${m}.${y}`; }
          
          let fillCol = textColor;
          if ((key === "baslik" || key === "altBaslik") && formData.kategori === "Günübirlik Akademi") {
             fillCol = "white";
          }

          // X koordinatı yoksa veya 50% ise ortala
          const isCentered = tCfg.x === undefined || tCfg.x === "50%";
          const posX = isCentered ? (1440 / 2) : tCfg.x;

          if (key === "egitimKonusu" && tCfg.labelY) {
            const labelTxt = new fabric.IText("EĞİTİM KONUSU", {
              left: posX * scale,
              top: tCfg.labelY * scale,
              fontSize: (tCfg.size - 10) * scale,
              fontFamily: fontFam,
              fontWeight: "bold",
              fill: fillCol,
              originX: isCentered ? "center" : "left",
              originY: "baseline",
              selectable: true, hasControls: true, borderColor: "#1a4d2e", cornerColor: "#1a4d2e"
            });
            fc.add(labelTxt);
          }

          let calcOriginX = "left";
          if (isCentered) calcOriginX = "center";
          else if (key === "tarih" || key === "gun") calcOriginX = "right";

          let finalY = tCfg.y;
          // Koordinatları orjinaline daha yakın bir güvenli alana alıyoruz (ikonların hemen sağına/soluna)
          if (formData.kategori === "Online Program") {
             if (key === "tarih" || key === "saat") finalY = 2345;
             if (key === "gun") finalY = 2390;
             if (key === "egitimKonusu") finalY = 2280;
          }

          if (key === "saat" || key === "tarih") {
             finalY -= 40;
          }

          const safeVal = val ? val.toUpperCase() : "BİLGİ YOK";

          const txt = new fabric.IText(safeVal, {
            left: posX * scale,
            top: finalY * scale,
            fontSize: (tCfg.size || 50) * scale,
            fontFamily: fontFam,
            fontWeight: "bold",
            fill: fillCol,
            originX: calcOriginX,
            originY: "top",
            selectable: true, 
            hasControls: true, 
            borderColor: "#1a4d2e", 
            cornerColor: "#1a4d2e",
            backgroundColor: "rgba(255,255,255,0.6)", // Ne olursa olsun görünmesi için hafif beyaz zemin
            shadow: new fabric.Shadow({ color: "rgba(255,255,255,0.9)", blur: 4 })
          });
          fc.add(txt);

          if (key === "saat") {
            const logoUrl = "/Assets/Images/ut.png";
            loadImage(logoUrl).then((utLogoImg) => {
              if (utLogoImg) {
                const logoWidth = 70;
                const logoHeight = utLogoImg.height * (logoWidth / utLogoImg.width);
                const logoLeft = (posX + 75) * scale;
                const logoTop = (finalY + (tCfg.size || 50) + 10) * scale;

                utLogoImg.set({
                  left: logoLeft,
                  top: logoTop,
                  scaleX: (logoWidth * scale) / utLogoImg.width,
                  scaleY: (logoWidth * scale) / utLogoImg.width,
                  originX: "center",
                  originY: "top",
                  selectable: true,
                  hasControls: true,
                  borderColor: "#1a4d2e",
                  cornerColor: "#1a4d2e",
                  cornerSize: 8
                });
                fc.add(utLogoImg);

                const webTxt = new fabric.IText("WEB", {
                  left: logoLeft,
                  top: logoTop + (logoHeight + 4) * scale,
                  fontSize: 24 * scale,
                  fontFamily: fontFam,
                  fontWeight: "bold",
                  fill: fillCol,
                  originX: "center",
                  originY: "top",
                  selectable: true,
                  hasControls: true,
                  borderColor: "#1a4d2e",
                  cornerColor: "#1a4d2e"
                });
                fc.add(webTxt);
                fc.renderAll();
              }
            });
          }
        }
      });

      fc.renderAll();

      fc.on("selection:created", (e) => setSelectedObj(e.selected?.[0] || null));
      fc.on("selection:updated", (e) => setSelectedObj(e.selected?.[0] || null));
      fc.on("selection:cleared", ()  => setSelectedObj(null));
      
      const saveHistory = () => {
        if (fc.historyProcessing) return;
        const json = fc.toJSON(['selectable', 'hasControls', 'borderColor', 'cornerColor', 'cornerSize', 'originX', 'originY']);
        fc.historyArr = fc.historyArr || [];
        fc.historyArr.push(JSON.stringify(json));
        setCanUndo(fc.historyArr.length > 1);
      };

      fc.on("object:modified", () => {
        saveHistory();
        setSelectedObj(fc.getActiveObject());
      });

      fc.on("object:added", () => { if (!fc.historyProcessing) saveHistory(); });
      fc.on("object:removed", () => { if (!fc.historyProcessing) saveHistory(); });

      // Save initial state after all loading is done
      setTimeout(() => { 
        fc.historyProcessing = false;
        saveHistory(); 
      }, 500);

      const handleKeyDown = (e) => {
        if (e.ctrlKey && e.key === 'z') {
          e.preventDefault();
          const btn = document.getElementById("undo-button-fabric");
          if (btn) btn.click();
        } else if (e.key === 'Delete' || e.key === 'Backspace') {
          // Eğer metin düzenleniyorsa silmeyi engelleme
          if (fc.getActiveObject() && fc.getActiveObject().isEditing) return;
          e.preventDefault();
          const btn = document.getElementById("delete-button-fabric");
          if (btn) btn.click();
        } else if (e.ctrlKey && (e.key === 'c' || e.key === 'C')) {
          if (fc.getActiveObject() && fc.getActiveObject().isEditing) return;
          e.preventDefault();
          const activeObj = fc.getActiveObject();
          if (activeObj) {
            activeObj.clone((cloned) => { fc._clipboard = cloned; });
          }
        } else if (e.ctrlKey && (e.key === 'v' || e.key === 'V')) {
          if (fc.getActiveObject() && fc.getActiveObject().isEditing) return;
          e.preventDefault();
          if (fc._clipboard) {
            fc._clipboard.clone((clonedObj) => {
              fc.discardActiveObject();
              clonedObj.set({
                left: clonedObj.left + 30,
                top: clonedObj.top + 30,
                evented: true,
              });
              if (clonedObj.type === 'activeSelection') {
                clonedObj.canvas = fc;
                clonedObj.forEachObject((obj) => fc.add(obj));
                clonedObj.setCoords();
              } else {
                fc.add(clonedObj);
              }
              // Sonraki yapıştırmalar için clipboard konumunu kaydır
              fc._clipboard.top += 30;
              fc._clipboard.left += 30;
              fc.setActiveObject(clonedObj);
              fc.fire('object:modified');
              fc.renderAll();
            });
          }
        }
      };
      const handleOutsideClick = (event) => {
        if (fc && fc.getActiveObject()) {
          const editorPanel = document.querySelector(".fabric-inline-panel");
          if (editorPanel && !editorPanel.contains(event.target)) {
            fc.discardActiveObject();
            fc.renderAll();
            setSelectedObj(null);
          }
        }
      };
      window.addEventListener("click", handleOutsideClick, true);

      window.addEventListener('keydown', handleKeyDown);
      fc.handleKeyDown = handleKeyDown;
      fc.handleOutsideClick = handleOutsideClick;
    };
    tmpImg.src = posterUrl;

    return () => {
      if (fabricRef.current) {
        if (fabricRef.current.handleKeyDown) window.removeEventListener('keydown', fabricRef.current.handleKeyDown);
        if (fabricRef.current.handleOutsideClick) window.removeEventListener('click', fabricRef.current.handleOutsideClick, true);
        fabricRef.current.dispose(); 
        fabricRef.current = null; 
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [posterUrl]);

  const deleteSelected = () => {
    const fc = fabricRef.current;
    const obj = fc?.getActiveObject();
    if (obj) { fc.remove(obj); setSelectedObj(null); }
  };

  const bringForward  = () => { const fc = fabricRef.current; fc?.bringForward(fc.getActiveObject()); fc?.fire('object:modified'); fc?.renderAll(); };
  const sendBackwards = () => { const fc = fabricRef.current; fc?.sendBackwards(fc.getActiveObject()); fc?.fire('object:modified'); fc?.renderAll(); };

  const changeFontSize = (delta) => {
    const fc = fabricRef.current;
    const obj = fc?.getActiveObject();
    if (obj && obj.type === "i-text") {
      obj.set("fontSize", Math.max(10, obj.fontSize + delta));
      fc.fire('object:modified');
      fc.renderAll();
      setSelectedObj(Object.assign({}, obj)); // Force re-render to update UI if needed
    }
  };

  const download = () => {
    const fc = fabricRef.current;
    if (!fc) return;
    fc.discardActiveObject(); fc.renderAll();
    const link = document.createElement("a");
    link.href = fc.toDataURL({ format: "png", multiplier: 2 });
    link.download = "afis_duzenlenmis.png";
    link.click();
  };

  const addImageFromFile = (e) => {
    const file = e.target.files[0];
    if (!file || !fabricRef.current) return;
    const url = URL.createObjectURL(file);
    const fc = fabricRef.current;
    fabric.Image.fromURL(url, (img) => {
      img.scaleToWidth(Math.min(fc.width * 0.35, 180));
      img.set({
        left: 30, top: 30,
        selectable: true, evented: true, lockUniScaling: false,
        borderColor: "#1a4d2e", cornerColor: "#1a4d2e",
        cornerSize: 12, transparentCorners: false,
        hasControls: true, hasBorders: true,
      });
      fc.add(img);
      fc.setActiveObject(img);
      fc.renderAll();
    });
    e.target.value = "";
  };

  const handleUndo = () => {
    const fc = fabricRef.current;
    if (!fc || !fc.historyArr || fc.historyArr.length <= 1) return;
    fc.historyProcessing = true;
    fc.historyArr.pop(); // discard current state
    const prevState = fc.historyArr[fc.historyArr.length - 1];
    setCanUndo(fc.historyArr.length > 1);
    fc.loadFromJSON(prevState, () => {
      fc.renderAll();
      fc.historyProcessing = false;
      setSelectedObj(fc.getActiveObject());
    });
  };

  const cloneSelected = () => {
    const fc = fabricRef.current;
    const activeObject = fc?.getActiveObject();
    if (!activeObject) return;

    activeObject.clone((cloned) => {
      cloned.set({
        left: cloned.left + 30,
        top: cloned.top + 30,
        evented: true,
      });
      if (cloned.type === 'activeSelection') {
        cloned.canvas = fc;
        cloned.forEachObject((obj) => fc.add(obj));
        cloned.setCoords();
      } else {
        fc.add(cloned);
      }
      fc.discardActiveObject();
      fc.setActiveObject(cloned);
      fc.fire('object:modified');
      fc.renderAll();
    });
  };

  const isText = selectedObj && selectedObj.type === "i-text";

  return (
    <div className="fabric-inline-panel">
      <div className="fabric-inline-header">
        <span className="fabric-inline-title">
          <i className="fa-solid fa-pen-ruler me-2"></i>Afiş Düzenleyici
        </span>
        <div className="fabric-toolbar-inline">
          <button id="undo-button-fabric" className={`fabric-tool-btn-sm ${!canUndo ? "disabled" : ""}`} onClick={handleUndo} title="Geri Al (Ctrl+Z)" disabled={!canUndo}>
            <i className="fa-solid fa-rotate-left me-1"></i>Geri Al
          </button>

          <label className="fabric-tool-btn-sm">
            <i className="fa-solid fa-image me-1"></i>Fotoğraf Ekle
            <input type="file" accept="image/*" onChange={addImageFromFile} style={{ display: "none" }} />
          </label>
          <button className={`fabric-tool-btn-sm ${!selectedObj ? "disabled" : ""}`} onClick={cloneSelected} disabled={!selectedObj} title="Çoğalt">
            <i className="fa-regular fa-copy me-1"></i>Çoğalt
          </button>
          <button className={`fabric-tool-btn-sm ${!selectedObj ? "disabled" : ""}`} onClick={bringForward} disabled={!selectedObj}>
            <i className="fa-solid fa-arrow-up me-1"></i>Öne
          </button>
          <button className={`fabric-tool-btn-sm ${!selectedObj ? "disabled" : ""}`} onClick={sendBackwards} disabled={!selectedObj}>
            <i className="fa-solid fa-arrow-down me-1"></i>Arkaya
          </button>
          <button id="delete-button-fabric" className={`fabric-tool-btn-sm danger ${!selectedObj ? "disabled" : ""}`} onClick={deleteSelected} disabled={!selectedObj}>
            <i className="fa-solid fa-trash me-1"></i>Sil
          </button>
          <button className="fabric-tool-btn-sm primary" onClick={download}>
            <i className="fa-solid fa-download me-1"></i>İndir
          </button>
        </div>
      </div>


      <div className="fabric-canvas-inner" ref={wrapperRef}>
        <canvas ref={canvasRef} />
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════════
   Ana Sayfa
══════════════════════════════════════════════════ */
const AfisOlusturucu = () => {
  useEffect(() => {
    if (!Cookies.get("token") && !localStorage.getItem("token")) window.location.href = "/login";
  }, []);

  const [loading,          setLoading]          = useState(false);
  const [posterUrl,        setPosterUrl]        = useState(null);
  const [personPreviewUrl, setPersonPreviewUrl] = useState(null);
  const fileInputRef = useRef(null);

  const [formData, setFormData] = useState({
    baslik: "", altBaslik: "", egitimKonusu: "", adres: "",
    tarih: new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Istanbul" }), // TR "bugün" (YYYY-MM-DD)
    gun: "PAZARTESİ", saat: "20:00",
    kategori: "Online Program", altKategori: "", kisiSayisi: "Tek Kişilik",
  });

  const [personList, setPersonList] = useState([]);
  const [currentPerson, setCurrentPerson] = useState({ isim: "", unvan: "6 Yıldız", rütbeId: "6 Yıldız", image: null });
  const [editingPersonId, setEditingPersonId] = useState(null);
  const [bulkQueue, setBulkQueue] = useState([]);
  const [currentQueueIndex, setCurrentQueueIndex] = useState(0);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [modalPerson, setModalPerson] = useState({ isim: "", unvan: "6 Yıldız" });



  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const nd = { ...prev, [name]: value };
      if (name === "tarih") {
        const days = ["PAZAR","PAZARTESİ","SALI","ÇARŞAMBA","PERŞEMBE","CUMA","CUMARTESİ"];
        const d = new Date(value);
        if (!isNaN(d)) nd.gun = days[d.getDay()];
      }
      if (name === "kategori") {
        nd.kisiSayisi = PERSON_COUNT_MAP[value]?.[0] || "Tek Kişilik";
        nd.altKategori = "";
        nd.altBaslik = value === "Online Program" ? "ONLINE" : "";
      }
      return nd;
    });
  };

  const handlePersonInputChange = (e) => {
    const { name, value } = e.target;
    setCurrentPerson((p) => ({ ...p, [name]: value, rütbeId: name === "unvan" ? value : p.rütbeId }));
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    const availableOptions = PERSON_COUNT_MAP[formData.kategori] || [];
    const maxLimit = Math.max(...availableOptions.map(o => parseInt(o) || 1));
    const remainingSlots = maxLimit - personList.length;

    if (remainingSlots <= 0) {
      alert(`Maksimum ${maxLimit} kişi sınırına ulaştınız.`);
      e.target.value = "";
      return;
    }

    const filesToProcess = files.slice(0, remainingSlots);
    if (files.length > remainingSlots) {
      alert(`Sadece boş kalan ${remainingSlots} kişilik yer için ilk ${remainingSlots} fotoğraf işlenecektir.`);
    }

    if (filesToProcess.length === 1) {
      const file = filesToProcess[0];
      setPersonPreviewUrl(URL.createObjectURL(file));
      
      let originalName = file.name.substring(0, file.name.lastIndexOf('.')) || file.name;
      let detectedUnvan = "6 Yıldız";
      const cleanNameLower = originalName.toLowerCase();

      for (const rank of RANK_OPTIONS) {
        if (cleanNameLower.includes(rank.toLowerCase())) {
          detectedUnvan = rank;
          originalName = originalName.replace(new RegExp(`\\s*[-_]\\s*${rank}`, 'i'), '');
          originalName = originalName.replace(new RegExp(`${rank}`, 'i'), '');
          break;
        }
      }

      const finalName = originalName
        .replace(/[-_]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

      setCurrentPerson((p) => ({
        ...p,
        isim: finalName || p.isim,
        unvan: detectedUnvan,
        rütbeId: detectedUnvan,
        image: file
      }));
    } else {
      const queue = filesToProcess.map((file) => {
        let originalName = file.name.substring(0, file.name.lastIndexOf('.')) || file.name;
        let detectedUnvan = "6 Yıldız";
        const cleanNameLower = originalName.toLowerCase();

        for (const rank of RANK_OPTIONS) {
          if (cleanNameLower.includes(rank.toLowerCase())) {
            detectedUnvan = rank;
            originalName = originalName.replace(new RegExp(`\\s*[-_]\\s*${rank}`, 'i'), '');
            originalName = originalName.replace(new RegExp(`${rank}`, 'i'), '');
            break;
          }
        }

        const finalName = originalName
          .replace(/[-_]/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();

        return {
          file,
          previewUrl: URL.createObjectURL(file),
          isim: finalName,
          unvan: detectedUnvan
        };
      });

      setBulkQueue(queue);
      setCurrentQueueIndex(0);
      setModalPerson({ isim: queue[0].isim, unvan: queue[0].unvan });
      setShowBulkModal(true);
    }

    e.target.value = "";
  };

  const handleAddQueueItem = () => {
    if (!modalPerson.isim.trim()) {
      alert("Lütfen isim girin.");
      return;
    }

    const currentItem = bulkQueue[currentQueueIndex];
    const newPerson = {
      id: Date.now() + Math.random(),
      isim: modalPerson.isim.trim(),
      unvan: modalPerson.unvan,
      rütbeId: modalPerson.unvan,
      image: currentItem.file,
      previewUrl: currentItem.previewUrl,
      src: currentItem.previewUrl
    };

    setPersonList((prev) => {
      const nextList = [...prev, newPerson];
      const count = nextList.length;
      const option = count === 1 ? "Tek Kişilik" : `${count} Kişilik`;
      const availableOptions = PERSON_COUNT_MAP[formData.kategori] || [];
      if (availableOptions.includes(option)) {
        setFormData((prevForm) => ({ ...prevForm, kisiSayisi: option }));
      }
      return nextList;
    });
    goToNextQueueItem();
  };

  const handleSkipQueueItem = () => {
    goToNextQueueItem();
  };

  const goToNextQueueItem = () => {
    if (currentQueueIndex + 1 < bulkQueue.length) {
      const nextIndex = currentQueueIndex + 1;
      setCurrentQueueIndex(nextIndex);
      setModalPerson({
        isim: bulkQueue[nextIndex].isim,
        unvan: bulkQueue[nextIndex].unvan
      });
    } else {
      setShowBulkModal(false);
      setBulkQueue([]);
    }
  };

  const handleCancelQueue = () => {
    bulkQueue.forEach(item => {
      if (item.previewUrl.startsWith("blob:")) URL.revokeObjectURL(item.previewUrl);
    });
    setShowBulkModal(false);
    setBulkQueue([]);
  };

  const addPersonToList = () => {
    if (!currentPerson.isim) { alert("İsim yazın."); return; }

    if (editingPersonId) {
      setPersonList((prev) => prev.map((p) => {
        if (p.id === editingPersonId) {
          return {
            ...p,
            isim: currentPerson.isim,
            unvan: currentPerson.unvan,
            rütbeId: currentPerson.unvan,
            image: currentPerson.image || p.image,
            previewUrl: personPreviewUrl || p.previewUrl,
            src: personPreviewUrl || p.src
          };
        }
        return p;
      }));
      setEditingPersonId(null);
      setCurrentPerson({ isim: "", unvan: "6 Yıldız", rütbeId: "6 Yıldız", image: null });
      setPersonPreviewUrl(null);
      if (fileInputRef.current) fileInputRef.current.value = "";
    } else {
      if (!currentPerson.image) { alert("Fotoğraf ekleyin."); return; }
      const limit = parseInt(formData.kisiSayisi) || 1;
      if (personList.length >= limit) { alert(`Maksimum ${formData.kisiSayisi} kişi eklenebilir.`); return; }
      const url = URL.createObjectURL(currentPerson.image);
      setPersonList((p) => [...p, { ...currentPerson, id: Date.now(), previewUrl: url, src: url }]);
      setCurrentPerson({ isim: "", unvan: "6 Yıldız", rütbeId: "6 Yıldız", image: null });
      setPersonPreviewUrl(null);
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  };

  const cancelEditing = () => {
    setEditingPersonId(null);
    setCurrentPerson({ isim: "", unvan: "6 Yıldız", rütbeId: "6 Yıldız", image: null });
    setPersonPreviewUrl(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleEditPerson = (p) => {
    setEditingPersonId(p.id);
    setCurrentPerson({
      isim: p.isim,
      unvan: p.unvan,
      rütbeId: p.unvan,
      image: p.image
    });
    setPersonPreviewUrl(p.previewUrl);
  };

  const removePerson = (id) => {
    setPersonList((prev) => {
      const t = prev.find((p) => p.id === id);
      if (t?.previewUrl?.startsWith("blob:")) URL.revokeObjectURL(t.previewUrl);
      return prev.filter((p) => p.id !== id);
    });
  };

  const fillWithTestData = () => {
    const limit = parseInt(formData.kisiSayisi) || 1;
    const needed = limit - personList.length;
    if (needed <= 0) { alert("Liste dolu."); return; }
    setPersonList((prev) => [
      ...prev,
      ...Array.from({ length: needed }, (_, i) => {
        const t = TEST_IMAGES[i % TEST_IMAGES.length];
        const rank = randomFrom(RANK_OPTIONS);
        return { id: Date.now() + i, isim: t.isim, unvan: rank, rütbeId: rank, image: null, previewUrl: t.src, src: t.src, isTestData: true };
      }),
    ]);
  };

  const handleGenerate = async () => {
    const target = parseInt(formData.kisiSayisi) || 1;
    if (personList.length < target) { alert(`${target} kişi gerekli, şu an ${personList.length}.`); return; }
    setLoading(true);
    const data = new FormData();
    const token = Cookies.get("token") || localStorage.getItem("token");

    // Saydam 1x1 piksel (Backend'in resmi afişe yapıştırmasını önlemek için)
    const transPixelBase64 = "iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";
    const transPixelBlob = await fetch(`data:image/png;base64,${transPixelBase64}`).then(res => res.blob());
    const transPixelFile = new File([transPixelBlob], "transparent.png", { type: "image/png" });

    // Tam düzenleme modunu açıyoruz ki backend resimleri, rozetleri ve yazıları eklemesin
    data.append("fullEditMode", "true");
    data.append("platform", "web");

    Object.keys(formData).forEach((key) => {
      let val = formData[key];
      if (key === "tarih" && val.includes("-")) { const [y,m,d] = val.split("-"); val = `${d}.${m}.${y}`; }
      
      // Backend'in yazıları "bake" etmesini engellemek için sadece boşluk (" ") gönderiyoruz.
      // Kategori ve KisiSayisi gibi şablon seçimini etkileyecek parametreler olduğu gibi gidiyor.
      if (["baslik", "altBaslik", "egitimKonusu", "adres", "tarih", "saat", "gun"].includes(key)) {
        data.append(key, " ");
      } else {
        data.append(key, val);
      }
    });

    for (let i = 0; i < personList.length; i++) {
      const p = personList[i];
      data.append(`personNames[${i}]`, p.isim);
      data.append(`personRanks[${i}]`, p.unvan);
      // Gerçek resim yerine saydam piksel gönderiyoruz
      // Böylece backend sadece isimleri ve arka planı çizer, resimler FabricJS ile önyüzde eklenir
      data.append("personImages", transPixelFile);
    }
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/afis-generator/uret`, {
        method: "POST", headers: { Authorization: `Bearer ${token}` }, body: data,
      });
      if (res.ok && res.headers.get("content-type")?.includes("image")) {
        setPosterUrl(URL.createObjectURL(await res.blob()));
      } else {
        alert("HATA: " + await res.text());
      }
    } catch { alert("Sunucuya bağlanılamadı."); }
    finally { setLoading(false); }
  };

  return (
    <div className="premium-afis-page">
      <Header isLoggedIn={true} />

      <div className="premium-content-area">
        <div className="premium-container">
          <div className="row g-4">

            {/* ── Sol Kolon: Form ── */}
            <div className="col-lg-6">
              <div className="premium-card">
                <h1 className="premium-title">Afiş Sihirbazı</h1>
                <p className="premium-subtitle">Profesyonel afişlerinizi saniyeler içinde oluşturun ve düzenleyin.</p>

                <div className="row mb-4">
                  <div className="col-md-6">
                    <label className="premium-label">Afiş Kategorisi</label>
                    <select name="kategori" value={formData.kategori} onChange={handleInputChange} className="premium-select">
                      <option value="Online Program">Online Program</option>
                      <option value="Offline Program">Offline Program</option>
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="premium-label">Kişi Sayısı</label>
                    <select name="kisiSayisi" value={formData.kisiSayisi} onChange={handleInputChange} className="premium-select">
                      {(PERSON_COUNT_MAP[formData.kategori] || []).map((o) => <option key={o} value={o}>{o}</option>)}
                    </select>
                  </div>
                </div>

                <div className="row mb-4">
                  <div className="col-md-6">
                    <label className="premium-label">Başlık</label>
                    <input name="baslik" value={formData.baslik} onChange={handleInputChange} className="premium-input" placeholder="BAYİ EĞİTİMİ" />
                  </div>
                  <div className="col-md-6">
                    <label className="premium-label">Alt Başlık</label>
                    <input name="altBaslik" value={formData.altBaslik} onChange={handleInputChange} className="premium-input" disabled={formData.kategori === "Online Program"} />
                  </div>
                </div>

                <div className="mb-4">
                  <label className="premium-label">Eğitim Konusu</label>
                  <input name="egitimKonusu" value={formData.egitimKonusu} onChange={handleInputChange} className="premium-input" placeholder="Ürün Eğitimi" />
                </div>

                {formData.kategori !== "Online Program" && (
                  <div className="mb-4">
                    <label className="premium-label">Adres</label>
                    <textarea name="adres" value={formData.adres} onChange={handleInputChange} className="premium-textarea" rows="2" />
                  </div>
                )}

                <div className="row mb-4">
                  <div className="col-md-4">
                    <label className="premium-label">Tarih</label>
                    <input type="date" name="tarih" value={formData.tarih} onChange={handleInputChange} className="premium-input" />
                  </div>
                  <div className="col-md-4">
                    <label className="premium-label">Gün</label>
                    <select name="gun" value={formData.gun} onChange={handleInputChange} className="premium-select">
                      {DAY_OPTIONS.map((d) => <option key={d} value={d}>{d}</option>)}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label className="premium-label">Saat</label>
                    <input type="time" name="saat" value={formData.saat} onChange={handleInputChange} className="premium-input" />
                  </div>
                </div>

                {/* Katılımcı */}
                <div className="add-person-section">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <h5 style={{ color: "var(--primary-color)", fontWeight: 600, margin: 0 }}>
                      <i className="fa-solid fa-user-plus me-2"></i>Katılımcı Ekle
                    </h5>
                  </div>

                  <div className="row g-3">
                    <div className="col-md-7">
                      <label className="premium-label">İsim Soyad</label>
                      <input name="isim" value={currentPerson.isim} onChange={handlePersonInputChange} className="premium-input" placeholder="Ad Soyad" />
                    </div>
                    <div className="col-md-5">
                      <label className="premium-label">Kariyer</label>
                      <div className="d-flex align-items-center gap-2">
                        <select name="unvan" value={currentPerson.unvan} onChange={handlePersonInputChange} className="premium-select">
                          {RANK_OPTIONS.map((r) => <option key={r} value={r}>{r}</option>)}
                        </select>
                        <img src={`/Assets/badges/${currentPerson.unvan}.png`} alt=""
                          style={{ width: 38, height: 38, objectFit: "contain", flexShrink: 0 }}
                          onError={(e) => e.target.style.display = "none"} />
                      </div>
                    </div>
                    <div className="col-12">
                      <label className="premium-label">Profil Fotoğrafı (Birden fazla seçerek toplu ekleyebilirsiniz!)</label>
                      <div className="upload-area">
                        {personPreviewUrl ? (
                          <>
                            <img src={personPreviewUrl} alt="preview" className="upload-preview-img" />
                            <div style={{ position: "absolute", bottom: 10, background: "rgba(0,0,0,.5)", color: "#fff", padding: "4px 12px", borderRadius: 20, fontSize: "0.7rem" }}>
                              Değiştirmek için tıklayın
                            </div>
                          </>
                        ) : (
                          <div className="text-center text-muted">
                            <i className="fa-solid fa-cloud-arrow-up fa-2x mb-2"></i>
                            <p className="small mb-0 fw-bold">Tekli veya Çoklu Fotoğraf Seçin / Sürükleyin</p>
                            <p className="text-muted" style={{ fontSize: "0.7rem", marginTop: 4 }}>Fotoğraf adları otomatik olarak isim ve kariyerle eşleşir!</p>
                          </div>
                        )}
                        <input type="file" ref={fileInputRef} multiple accept="image/*" onChange={handleFileChange} />
                      </div>
                    </div>
                    <div className="col-12 d-flex gap-2">
                      <button type="button" onClick={addPersonToList} className="btn-generate m-0"
                        style={{ background: editingPersonId ? "var(--secondary-color)" : "white", color: editingPersonId ? "white" : "var(--primary-color)", border: `2px solid ${editingPersonId ? "var(--secondary-color)" : "var(--primary-color)"}`, boxShadow: "none", padding: 12 }}>
                        {editingPersonId ? "BİLGİLERİ GÜNCELLE" : "LİSTEYE EKLE"}
                      </button>
                      {editingPersonId && (
                        <button type="button" onClick={cancelEditing} className="btn-generate m-0"
                          style={{ background: "white", color: "#627d98", border: "2px solid #e1e8ed", boxShadow: "none", padding: 12 }}>
                          VAZGEÇ
                        </button>
                      )}
                    </div>
                  </div>

                  <div className="person-chip-grid">
                    {personList.map((p) => (
                      <div key={p.id} className={`person-chip ${editingPersonId === p.id ? "editing-active" : ""}`} onClick={() => handleEditPerson(p)} title="Düzenlemek için tıklayın">
                        <button onClick={(e) => { e.stopPropagation(); removePerson(p.id); }} className="remove-person-btn">
                          <i className="fa-solid fa-times"></i>
                        </button>
                        <img src={p.previewUrl || p.src} alt={p.isim} />
                        <div className="person-chip-info">
                          <p className="person-chip-name">{p.isim}</p>
                          <p style={{ fontSize: "0.65rem", margin: 0, color: "#627d98" }}>{p.unvan}</p>
                          {p.isTestData && <span style={{ fontSize: "0.55rem", background: "#e0f7fa", color: "#00838f", borderRadius: 4, padding: "1px 4px" }}>test</span>}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <button onClick={handleGenerate} className="btn-generate" disabled={loading || personList.length === 0}>
                  {loading ? "HAZIRLANIYOR..." : "AFİŞİ OLUŞTUR"}
                </button>
              </div>
            </div>

            {/* ── Sağ Kolon: Fabric Editör (veya boş önizleme) ── */}
            <div className="col-lg-6">
              {posterUrl ? (
                <FabricEditor posterUrl={posterUrl} personList={personList} formData={formData} />
              ) : (
                <div className="premium-preview">
                  {loading ? (
                    <div className="text-center">
                      <div className="premium-loader mb-3"></div>
                      <p className="fw-bold text-muted">Hazırlanıyor...</p>
                    </div>
                  ) : (
                    <div className="text-center text-muted opacity-50">
                      <i className="fa-solid fa-wand-magic-sparkles fa-4x mb-3"></i>
                      <p className="fw-bold">Editör burada açılacak</p>
                      <p className="small">Afiş oluşturunca buraya yüklenecek.</p>
                    </div>
                  )}
                </div>
              )}
            </div>

          </div>
        </div>
      </div>
      {/* ─── Toplu Katılımcı Detay Giriş Modalı ─── */}
      {showBulkModal && bulkQueue.length > 0 && (
        <div className="fabric-editor-overlay" style={{ zIndex: 9999 }}>
          <div className="fabric-editor-modal" style={{ maxWidth: "500px", padding: "24px" }}>
            <div className="d-flex align-items-center justify-content-between mb-4">
              <h5 style={{ color: "white", fontWeight: 700, margin: 0 }}>
                Katılımcı Bilgilerini Düzenle ({currentQueueIndex + 1} / {bulkQueue.length})
              </h5>
              <button type="button" className="fabric-close-btn" onClick={handleCancelQueue}>
                <i className="fa-solid fa-times"></i>
              </button>
            </div>

            <div className="text-center mb-4">
              <img
                src={bulkQueue[currentQueueIndex].previewUrl}
                alt="preview"
                style={{ width: "150px", height: "185px", objectFit: "cover", borderRadius: "16px", boxShadow: "0 10px 25px rgba(0,0,0,0.3)" }}
              />
            </div>

            <div className="mb-3">
              <label className="premium-label" style={{ color: "#9aa5b1" }}>İsim Soyad</label>
              <input
                type="text"
                className="premium-input"
                style={{ background: "#1f2937", border: "2px solid #374151", color: "white" }}
                value={modalPerson.isim}
                onChange={(e) => setModalPerson(prev => ({ ...prev, isim: e.target.value }))}
                placeholder="Ad Soyad"
              />
            </div>

            <div className="mb-4">
              <label className="premium-label" style={{ color: "#9aa5b1" }}>Kariyer</label>
              <div className="d-flex align-items-center gap-3">
                <select
                  className="premium-select"
                  style={{ background: "#1f2937", border: "2px solid #374151", color: "white" }}
                  value={modalPerson.unvan}
                  onChange={(e) => setModalPerson(prev => ({ ...prev, unvan: e.target.value }))}
                >
                  {RANK_OPTIONS.map((r) => <option key={r} value={r}>{r}</option>)}
                </select>
                <img
                  src={`/Assets/badges/${modalPerson.unvan}.png`}
                  alt=""
                  style={{ width: 44, height: 44, objectFit: "contain" }}
                  onError={(e) => e.target.style.display = "none"}
                />
              </div>
            </div>

            <div className="d-flex gap-2">
              <button
                type="button"
                className="btn-generate m-0"
                style={{ background: "transparent", color: "#ef4444", border: "2px solid #ef4444", flex: 1, padding: 12 }}
                onClick={handleSkipQueueItem}
              >
                Atla / Ekleme
              </button>
              <button
                type="button"
                className="btn-generate m-0"
                style={{ background: "var(--primary-color)", color: "white", border: "none", flex: 2, padding: 12 }}
                onClick={handleAddQueueItem}
              >
                Katılımcıyı Ekle
              </button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default AfisOlusturucu;
